import { EUserStatusActionTypes, IUserStatusPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить статус юзера
 */
export const setUserStatus = actionGenerator<EUserStatusActionTypes.Set, IUserStatusPayload>(
  EUserStatusActionTypes.Set,
);

/**
 * Локально обновить статус юзера на минуту
 */
export const updateUserStatus = actionGenerator<EUserStatusActionTypes.Update, { userId: number }>(
  EUserStatusActionTypes.Update,
);
